// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__2rQH4","col":"CardReaderDesc_col__28eM3","label":"CardReaderDesc_label__20RVH"};